import { all, put, takeEvery } from "redux-saga/effects";
import { fetcher, getErrorMsg, handleError } from "lib/fetch";
import * as actions from "./actions";

const url = "companies"

function* loadCompanies(action) {
  try {
    const { params, token } = action.payload;
    const res = yield fetcher.post(url, params, token);
    yield put(actions.loadCompanies.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.loadCompanies.failure(getErrorMsg(error)));
  }
}

function* showCompany(action) {
  try {
    const { id, token } = action.payload;
    const res = yield fetcher.get(`${url}/${id}`, token);
    yield put(actions.showCompany.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.showCompany.failure(getErrorMsg(error)));
  }
}

function* createCompany(action) {
  try {
    const { params, token } = action.payload;
    const res = yield fetcher.post(`${url}/create`, params, token);
    yield put(actions.createCompany.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.createCompany.failure(getErrorMsg(error)));
  }
}

function* updateCompany(action) {
  try {
    const { params, id, token } = action.payload;
    const res = yield fetcher.post(`${url}/update/${id}`, params, token);
    yield put(actions.updateCompany.success(res.data));
   
  } catch (error) {
    handleError(error);
    yield put(actions.updateCompany.failure(getErrorMsg(error)));
  }
}

function* deleteCompany(action) {
  try {
    const { id, token } = action.payload;
    yield fetcher.get(`${url}/delete/${id}`, token);
    yield put(actions.deleteCompany.success(id));
  } catch (error) {
    handleError(error);
    yield put(actions.deleteCompany.failure(getErrorMsg(error)));
  }
}

function* importCompany(action) {
  try {
    const { file, token } = action.payload;
    const formData = new FormData();
    formData.append("file_name", file.originFileObj);
    const res = yield fetcher.upload(`${url}/import`, formData, token);
    yield put(actions.importCompany.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.importCompany.failure(getErrorMsg(error)));
  }
}

function* exportCompany(action) {
  try {
    const { token, company_id } = action.payload;
    const params = {
      page: 1,
      pageSize: 10,
      orderBy: "code",
      orderType: "desc",
      filterObj: {
        code: "",
        name: "",
        parent_company_id: company_id || ""
      }
    };
    const res = yield fetcher.post(`${url}/export`, params, token);
    yield put(actions.exportCompany.success(res.data));
    fetcher.download(res.data.data);
  } catch (error) {
    handleError(error);
    yield put(actions.exportCompany.failure(getErrorMsg(error)));
  }
}

export default function* watchDistance() {
  yield all([
    takeEvery(actions.LOAD_COMPANY.REQUEST, loadCompanies),
    takeEvery(actions.SHOW_COMPANY.REQUEST, showCompany),
    takeEvery(actions.CREATE_COMPANY.REQUEST, createCompany),
    takeEvery(actions.UPDATE_COMPANY.REQUEST, updateCompany),
    takeEvery(actions.DELETE_COMPANY.REQUEST, deleteCompany),
    takeEvery(actions.IMPORT_COMPANY.REQUEST, importCompany),
    takeEvery(actions.EXPORT_COMPANY.REQUEST, exportCompany),
  ]);
}
